import { IBrokerOfficeObjectResponse } from '@/types';
import { RealEstateAgentSchema } from '@/types/structuredData';
import { PATHS } from '@/constants';
import { normalizeText } from '@/common';

export const generateBrokerDetailSchema = (
  data: IBrokerOfficeObjectResponse,
): RealEstateAgentSchema => {
  const phone = data.contacts?.phone?.telUri ?? data.contacts?.phone?.formatted;
  const email = data.contacts?.email;
  const location = data.location;
  const coordinates = location?.coordinates;

  const formatRange = (range?: {
    from?: number | null;
    to?: number | null;
    currency?: string | null;
  }) => {
    if (!range?.to) return undefined;
    const currency = !range.currency || range.currency === 'EUR' ? '€' : range.currency;
    const from =
      range.from && range.from > 0 ? `${range.from.toLocaleString('de-AT')} ${currency} – ` : '';
    return `${from}${range.to.toLocaleString('de-AT')} ${currency}`;
  };
  const saleRange = formatRange(data.statistics?.priceRanges?.sale ?? undefined);
  const rentRange = formatRange(data.statistics?.priceRanges?.rent ?? undefined);
  const priceRange = [saleRange, rentRange].filter(Boolean).join(' / ') || undefined;
  const slug = data.directLink ?? data.slug;
  const pageUrl = `${process.env.BASE_URL}/${PATHS.BROKERS}/${slug}`;
  const aboutUs = data.content?.aboutUs ? normalizeText(data.content.aboutUs) : undefined;
  const regions = data.statistics?.regions?.length ? data.statistics.regions : undefined;

  return {
    '@context': 'https://schema.org',
    '@type': 'RealEstateAgent',
    name: data.name || '',
    url: data.contacts?.website ?? pageUrl,
    image: data.branding?.bigLogo ?? data.branding?.logo ?? undefined,
    description: aboutUs,
    priceRange,
    telephone: phone ?? undefined,
    email: email ?? undefined,
    foundingDate: data.content?.founded ? String(data.content.founded) : undefined,
    areaServed: regions,
    geo:
      coordinates?.lat && coordinates?.lng
        ? {
            '@type': 'GeoCoordinates',
            latitude: coordinates.lat,
            longitude: coordinates.lng,
          }
        : undefined,
    address:
      location?.addressLine || location?.zip || location?.town
        ? {
            '@type': 'PostalAddress',
            streetAddress: location?.addressLine ?? undefined,
            addressLocality: location?.town ?? undefined,
            postalCode: location?.zip ?? undefined,
            addressCountry: location?.countryCode ?? 'AT',
          }
        : undefined,
  };
};
